export const STATIC_BUCKET_PATH =
  "https://klasha-public-assets.s3.eu-west-3.amazonaws.com";

export enum API_ROUTES {
  GET_ALL_WALLET_TRANSACTIONS = "/wallet/admin/transaction/paginated/filter",
  GET_WALLET_CURRENCY_TRANSACTIONS = "/wallet/admin/transaction/paginated/filter",
  GET_WALLET_DEPOSIT_REQUESTS = "/wallet/funding/business/wallet/v2/filter/paginated",
  UPDATE_WALLET_DEPOSIT_REQUEST = "/wallet/funding/business/wallet/update/payment/status/",
  GET_SETTLEMENTS_PAYIN_DETAILS = "/wallet/virtual/account/collection/filter/paginated",
  GET_SETTLEMENTS_PAYOUT_DETAILS = "/wallet/foreign/banktransfer/request/admin/transaction/paginated/filter",
  GET_VIRTUAL_ACCOUNT_TRANSACTIONS = "/nucleus/virtual/account/collections/filter/paginated",
  GET_CUSTOMER_PAYMENT_LINKS = "/merchant/paylink/business",
  DELETE_CUSTOMER_PAYMENT_LINK = "/merchant/paylink/delete",
  SHARE_CUSTOMER_LINK = "/merchant/paylink/share",
  GET_KLASHA_WIRE_PAYMENTS = "/merchant/bulkmerchantpayment/admin/paginated/filter",
  GET_EXCHANGE_RATES = "/nucleus/general/exchange/all",
  GET_RATE = "/nucleus/general/exchange",
  GET_ALL_REFUNDS = "/nucleus/refund/filter/paginated",
  GET_ALL_TRANSACTIONS = "/nucleus/tnx/paginated/filter",
  GET_ALL_CUSTOMERS = "/wallet/virtual/v2/filter/paginated",
  GET_ALL_PAYIN_COLLECTIONS = "nucleus/tnx/filter/paginated",
  GET_ALL_PAYOUT_COLLECTIONS = "wallet/withdraw/merchant/request/admin/transaction/paginated/filter",
}

export const DEFAULT_STALE_TIME = 5 * 60 * 1000;
export const DEFAULT_CACHE_TIME = 10 * 60 * 1000;

export const MINIMUM_USD = process.env.REACT_APP_ENV === "dev" ? 1 : 100;

/* Temporarily hardcode specific emails and confirm if posthog can support this*/
export const STATIC_MERCHANT_EMAILS = [
  "fadeniji@klasha.com",
  "gabriel@klasha.com",
  "stephen@klasha.com",
  "odochi@klasha.com",
  "odochiokara@gmail.com",
  "romokeoladejo+62@gmail.com",
  "onioludamola+023@gmail.com",
  "klashazar@gmail.com",
  "romokeoladejo+67@gmail.com",
  "romokeoladejo+81@gmail.com ",
];
